import { atomWithQuery } from "jotai-tanstack-query";
import {
  fetchTaggingInformationData,
  getHTMLData,
  loadOnboardingData,
} from "../../apis";
import { atom } from "jotai";
import { atomWithLocalStorage } from "../../storage";

export const htmlDataTypeAtom = atom<string>("");

export const htmlDataAtom = atomWithQuery((get) => ({
  queryKey: ["htmlData", get(htmlDataTypeAtom)],
  queryFn: async (params) => {
    const type = params.queryKey[1] as string;
    if (type.length === 0) return null;
    return getHTMLData(type);
  },
}));

export const taggingInformationDataAtom = atomWithQuery((get) => ({
  queryKey: ["taggingInformationData"],
  queryFn: async () => {
    return fetchTaggingInformationData();
  },
}));

// export const onBoardingResultAtom = atomWithQuery((get) => ({
//   queryKey: ["onBoardingResult"],
//   queryFn: async () => {
//     return loadOnboardingData();
//   },
// }));

export const dontShowGettingStartedBasicTaggingAtom = atomWithLocalStorage(
  "dontShowGettingStartedBasicTagging",
  false
);
